export default __webpack_public_path__ + "static/media/icaew_background_xl1.4333534a.jpg";